var React = require('react');

function CircleBorder (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M716.58,775.78c-309,0-577.94-171.69-716.58-424.89V900H1440V338.15C1303.49,598.31,1030.77,775.78,716.58,775.78Z","transform":"translate(0 -338.15)"}));
}

CircleBorder.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 1440 561.85"};

module.exports = CircleBorder;

CircleBorder.default = CircleBorder;
